
import api from '@/api';
import { Edital } from '../model/Edital';

export class EditalViewModel {
  static async getEditaisByProcesso(processoId: string): Promise<Edital[]> {
    try {
      const response = await api.get(`/processos/${processoId}/editais`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar editais:', error);
      throw error;
    }
  }

  static async getEditaisWithChamadaAtual(processoId: string, tipoBancaId: string): Promise<Edital[]> {
    try {
      const response = await api.get(`/processos/${processoId}/editais/chamada-atual?tipoBancaId=${tipoBancaId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar editais com chamada atual:', error);
      throw error;
    }
  }
}